import tinySlider from '../plugins/tiny_slider'

document.addEventListener('turbolinks:load', function(){
  tinySlider.init()
})
